import PropTypes from "prop-types";
import { compose } from "recompose";
import { reduxForm } from "redux-form";

import HoldReturns from "../../../components/ReturnSettings/HoldReturns";
import ShippingSettings from "../../../components/ShippingSettings/ShippingSettings";
import { ANALYTICS_FOR_USER } from "../../../constants/analytics";
import { USER_DETAILS_FORMS } from "../../../constants/forms";
import { HOLD_RETURNS } from "../../../constants/strings";
import { getReturnSettingsInitialValues } from "../../../features/userDetailsForm/returnSettings/returnSettings.models";

const returnSettingsTabs = [
  {
    label: HOLD_RETURNS,
    analyticsId: ANALYTICS_FOR_USER.CLICK_HOLD_RETURNS,
    component: HoldReturns,
  },
];

const CustomerReturnSettings = ({ onInputChange }) => (
  <ShippingSettings
    shippingSettingsTabs={returnSettingsTabs}
    onInputChange={onInputChange}
  />
);

CustomerReturnSettings.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default compose(
  reduxForm({
    form: USER_DETAILS_FORMS.RETURN_SETTINGS,
    initialValues: getReturnSettingsInitialValues(),
  })
)(CustomerReturnSettings);
